/**
 * API 配置文件
 * 用于管理接口地址和环境切换
 */

// ⚙️ Debug Mode 开关 - 根据环境自动设置
// 开发环境（npm run start）: 自动使用本地服务
// 生产环境（npm run build）: 自动使用远程服务
const DEBUG_MODE = process.env.NODE_ENV === 'development';

const DEV_BASE_URL = process.env.REACT_APP_API_BASE_URL_DEV || 'http://localhost:8080';
const PROD_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// 接口地址配置
const API_CONFIG = {
  // 本地开发环境
  development: {
    baseURL: DEV_BASE_URL,
    timeout: 30000  // 增加到 30 秒，避免慢接口超时
  },
  // 生产环境
  production: {
    baseURL: PROD_BASE_URL,
    timeout: 30000  // 增加到 30 秒，避免慢接口超时
  }
};

// 根据 DEBUG_MODE 自动选择配置
const currentConfig = DEBUG_MODE ? API_CONFIG.development : API_CONFIG.production;

// 导出当前配置
export const API_BASE_URL = currentConfig.baseURL;
export const API_TIMEOUT = currentConfig.timeout;
export const IS_DEBUG_MODE = DEBUG_MODE;

const apiConfig = {
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  isDebugMode: IS_DEBUG_MODE
};

export default apiConfig;
